import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext, ThemeContext } from '../../../auth';
import { useMediaQuery } from 'react-responsive';
import { HeaderWeb, SidebarComponent } from '../../../components';
import { Button, Card, Col, Form, InputGroup, Row, Spinner, Table } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';
import { ModalDetailPcpSewa, ModalUbahLead, ModalUbahPcpDetail } from '../../../components/Modal';
import { axiosAuth } from '../../../api';
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { Formik } from 'formik';
import Swal from 'sweetalert2';

function PcpDetail() {

    const location = useLocation();
    const { data } = location.state || {};
    const { theme } = useContext(ThemeContext);
    const { userInfo, showSidebar, accessToken } = useContext(AuthContext);
    const isMobile = useMediaQuery({ maxWidth: 1024 });
    const [pcpData, setPcpData] = useState({});
    const [pcpDetail, setPcpDetail] = useState([]);
    const [listCategory, setListCategory] = useState([]);
    const [wapu, setWapu] = useState(data?.isWapu || false);
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const retrievePCP = () => {

        axiosAuth.get(data?.orderType === 'penjualan' ?
            `/api/pcp?leadId=${data?.id}` :
            `/api/pcp/sewa?leadId=${data?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setPcpData(res.data.data);


            }).catch(err => {
                console.error(err);

            })
    };

    const retrievePCPDetail = () => {

        axiosAuth.get(data?.orderType === 'penjualan' ?
            `/api/pcp/details?pcpId=${pcpData?.id}` :
            `/api/pcp/sewa/details?pcpId=${pcpData?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setPcpDetail(res.data.data);

            }).catch(err => {
                console.error(err);
            })
    };

    const retrieveCategoryProduct = () => {

        axiosAuth.get(`/api/pcp/categories`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,

                },

            })
            .then(res => {

                // setListCategory(res.data.data);

                const filteredData = res.data.data.filter((category) => category?.categoryName != 'Solusi');

                setListCategory(pcpData?.lead?.orderType == 'penjualan' ? filteredData : res.data.data);

                // console.log(res.data.data)

            }).catch(err => {
                console.error(err);

            })
    };

    useEffect(() => {
        if (accessToken !== undefined && data?.id !== undefined) retrievePCP();
    }, [accessToken, data?.id]);

    useEffect(() => {
        if (accessToken !== undefined && pcpData?.id !== undefined) retrievePCPDetail();
    }, [accessToken, pcpData?.id]);

    useEffect(() => {
        if (accessToken !== undefined && pcpData !== undefined) retrieveCategoryProduct();
    }, [accessToken, pcpData]);

    const numberFormat = (value) =>
        new Intl.NumberFormat('IN-ID', {
            style: 'currency',
            currency: 'IDR'
        }).format(value);

    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1)
    };

    const [rowSelected, setRowSelected] = useState({});
    const [showDetailPcpPenjualan, setShowDetailPcpPenjualan] = useState(false);

    const handleShowDetailPcpPenjualan = (item) => {
        setShowDetailPcpPenjualan(true);
        setRowSelected(item);
    };

    const [showDetailPcpSewa, setShowDetailPcpSewa] = useState(false);

    const handleShowDetailPcpSewa = (item) => {
        setShowDetailPcpSewa(true);
        setRowSelected(item);
    };

    const [leadDetail, setLeadDetail] = useState();

    const retrieveLeadDetail = () => {

        axiosAuth.get(`/api/leads/${pcpData?.lead?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setLeadDetail(res?.data?.data);

            }).catch(err => {
                console.error(err);
            })
    };

    useEffect(() => {
        if (accessToken !== undefined && pcpData?.lead?.id !== undefined) retrieveLeadDetail();
    }, [accessToken, pcpData?.lead?.id]);

    const [rowSelectedLead, setRowSelectedLead] = useState();
    const [showEditLead, setShowEditLead] = useState(false);
    const handleShowEditLead = (leadDetail) => {
        setShowEditLead(true);
        setRowSelectedLead(leadDetail);
    };

    const creditScore = pcpData?.lead?.customer?.creditScore;

    const renderStars = (score) => {
        const totalStars = 5;
        const stars = [];

        for (let i = 1; i <= totalStars; i++) {
            if (i <= score) {
                stars.push(<AiFillStar key={i} color="#fcd34d" size={24} />);
            } else {
                stars.push(<AiOutlineStar key={i} color="#fcd34d" size={24} />);
            }
        }

        return stars;
    };

    const pcpDate = new Date(pcpData?.lead?.date);
    const day = String(pcpDate.getDate()).padStart(2, '0');
    const month = String(pcpDate.getMonth() + 1).padStart(2, '0');
    const year = pcpDate.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    const [ppnPercentage, setPpnPercentage] = useState(11);

    const [totalHargaJual, setTotalHargaJual] = useState(0);

    const overHead = totalHargaJual * 0.03;

    const [edlCost, setEdlCost] = useState(0);

    const [deliveryCost, setDeliveryCost] = useState(0);

    const [financialCost, setFinancialCost] = useState(0);

    const [otherFinancialCost, setOtherFinancialCost] = useState(0);

    const [otherAllowance, setOtherAllowance] = useState(0);

    const subTotalCost =
        (parseFloat(overHead) || 0) +
        (parseFloat(edlCost) || 0) +
        (parseFloat(deliveryCost) || 0) +
        (parseFloat(financialCost) || 0) +
        (parseFloat(otherFinancialCost) || 0) +
        (parseFloat(otherAllowance) || 0);

    const totalHargaBeli = pcpDetail?.reduce((total, item) => total + ((item.buyingPrice * item.quantity) || 0), 0);

    const grossMargin = parseFloat(totalHargaJual) - parseFloat(totalHargaBeli) || 0;

    const nettMargin = parseFloat(grossMargin) - parseFloat(subTotalCost) || 0;

    useEffect(() => {

        if (pcpData?.lead?.orderType === 'penjualan') {
            const total = pcpDetail.reduce((acc, item) => {
                const subTotal =
                    parseFloat(item.sellingPrice) *
                    parseInt(item.quantity, 10)
                return acc + subTotal;
            }, 0);

            setTotalHargaJual(total);
        } else {
            const total = pcpDetail.reduce((acc, item) => {
                const subTotal =
                    parseFloat(item.sellingPrice) *
                    parseInt(item.quantity, 10) *
                    parseInt((item.duration / 30), 10);
                return acc + subTotal;
            }, 0);

            setTotalHargaJual(total);
        }

    }, [pcpDetail]);

    const ppnAmount = totalHargaJual * (ppnPercentage / 100);

    const grandTotalRaw = totalHargaJual + ppnAmount;

    const remainder = grandTotalRaw % 100;
    const grandTotal = remainder >= 50
        ? Math.round(grandTotalRaw + (100 - remainder))
        : Math.round(grandTotalRaw - remainder);


    const defaultValue = {
        projectName: pcpData?.projectName || "",
        description: pcpData?.description || "",
        franco: pcpData?.franco || "",
    };

    useEffect(() => {

        setPpnPercentage(pcpData?.ppnPercentage || 11);

        setEdlCost(pcpData?.externalDirectLabor || 0);

        setDeliveryCost(pcpData?.deliveryCost || 0);

        setFinancialCost(pcpData?.financialCost || 0);

        setOtherFinancialCost(pcpData?.otherFinancialCost || 0);

        setOtherAllowance(pcpData?.otherAllowance || 0);

        if (pcpData && pcpData.isWapu !== undefined) {
            setWapu(pcpData.isWapu);
        }

    }, [pcpData]);

    function handleChangeEDL(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;
        setEdlCost(numericValue);
    }

    function handleChangeDeliveryCost(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;
        setDeliveryCost(numericValue);
    }

    function handleChangeFinancialCost(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;
        setFinancialCost(numericValue);
    }

    function handleChangeOtherFinanceCost(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;
        setOtherFinancialCost(numericValue);
    }

    function handleChangeOtherAllowance(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;
        setOtherAllowance(numericValue);
    }

    const nettPercentage = parseInt(nettMargin) / parseInt(totalHargaJual) * 100 || 0;


    const handleSubmitPCPSewa = async (values) => {

        setIsSubmitting(true);
        setDisabled(true);

        const dataPCP = {
            ppnPercentage: parseInt(ppnPercentage),
            ppn: ppnAmount,
            isWapu: wapu,
            grandTotal: grandTotal,
            salesTotal: totalHargaJual,
            ...values,
        };

        try {

            const response = await axiosAuth.put(`/api/pcp/sewa/${pcpData?.id}`, dataPCP, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleBack();

            Swal.fire({
                icon: 'success',
                title: 'Berhasil mengupdate Pcp',
                showConfirmButton: true,
            });

            setIsSubmitting(false);
            setDisabled(false);

        } catch (err) {

            console.error(err);

            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat mengupdate Pcp',
            });

            setIsSubmitting(false);
            setDisabled(false);

        } finally {

            setIsSubmitting(false);
            setDisabled(false);

        }
    };

    const handleSubmitPCPPenjualan = async (values) => {

        setIsSubmitting(true);
        setDisabled(true);

        const dataPCP = {
            projectName: values.projectName,
            description: values.description,
            salesTotal: parseInt(totalHargaJual || 0),
            ppn: ppnAmount,
            ppnPercentage: parseInt(ppnPercentage),
            grandTotal: grandTotal,
            isWapu: wapu,
            overhead: overHead || 0,
            deliveryCost: parseInt(deliveryCost || 0),
            externalDirectLabor: parseInt(edlCost || 0),
            financialCost: parseInt(financialCost || 0),
            otherFinancialCost: parseInt(otherFinancialCost || 0),
            otherAllowance: parseInt(otherAllowance || 0),
            purchasesTotal: totalHargaBeli,
        };

        try {

            const response = await axiosAuth.put(`/api/pcp/${pcpData?.id}`, dataPCP, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleBack();

            Swal.fire({
                icon: 'success',
                title: 'Berhasil mengupdate Pcp',
                showConfirmButton: true,
            });

            setIsSubmitting(false);
            setDisabled(false);

        } catch (err) {
            console.error(err);

            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat mengupdate Pcp',
            });

            setIsSubmitting(false);
            setDisabled(false);

        } finally {

            setIsSubmitting(false);
            setDisabled(false);

        }

    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        inputQty: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            maxWidth: '90px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        nettMargin: {
            fontFamily: 'Poppins-Medium',
            color: nettMargin <= 300000
                ? 'red'
                : theme === 'light'
                    ? '#FFFFFF'
                    : '#222222',
            minHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        inputBodyGroup: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            maxWidth: '90px',
            maxHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
    };

    const selectStyles = {
        control: (cityided, state) => ({
            ...cityided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            textAlign: 'left',
            fontFamily: 'Poppins-Regular',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : state.isFocused ? '#f5f5f5' : '#fff',
            fontFamily: 'Poppins-Regular',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
    };

    return (
        <div style={{
            overflowX: 'hidden',
            maxWidth: '100vw',
            backgroundColor: theme === 'light' ? '#121212' : '#FFFFFF',
            transition: '0.8s'
        }}>
            <SidebarComponent />
            <div id={theme === 'light' ? 'containerAppDark' : 'containerAppLight'}
                style={{
                    width: isMobile ? '100%' : `calc(100% - ${showSidebar ? '78px' : '190px'})`,
                    marginLeft: isMobile ? '0px' : showSidebar ? '78px' : '190px',
                    transition: '0.8s'
                }}
            >
                <div className={isMobile ? 'ms-2' : 'ms-3 me-3'}>
                    <Row>
                        <Col xs={6} lg={6} className='text-start'>
                            <Row>
                                <Col>
                                    <h5 className='pt-4' style={{ fontFamily: 'Poppins-Medium', fontSize: isMobile ? '25px' : '38px', color: theme === 'light' ? '#FFFFFF' : '', marginBottom: '0px' }}>
                                        {pcpData?.lead?.noLead}
                                    </h5>
                                </Col>
                                <Col>
                                    <div className='pt-4'>
                                        <Button
                                            variant='btn'
                                            id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                            onClick={() => handleShowEditLead(leadDetail)}
                                        >
                                            Lihat
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                            <p style={{ fontFamily: 'Poppins-Regular', fontSize: '18px', color: theme === 'light' ? '#FFFFFF' : '', marginBottom: '0px' }}>
                                Tanggal: {formattedDate}
                            </p>
                        </Col>
                        <Col xs={6} lg={6} className={isMobile === false ? 'text-end my-auto' : 'text-end my-auto pt-4'}>
                            <HeaderWeb />
                        </Col>
                    </Row>
                </div>
                <Formik
                    initialValues={defaultValue}
                    enableReinitialize={true}
                    onSubmit={pcpData?.lead?.orderType === 'penjualan' ?
                        handleSubmitPCPPenjualan
                        :
                        handleSubmitPCPSewa
                    }
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values
                    }) => {
                        return (
                            <Form onSubmit={handleSubmit}>
                                <div className={isMobile ? 'ms-1 mt-4' : 'ms-3 mt-4'}>
                                    <Row>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='customer'>Customer</Form.Label>
                                            <Form.Control
                                                id='customer'
                                                type="text"
                                                defaultValue={pcpData?.lead?.customer?.name || ''}
                                                readOnly
                                                style={formStyles.input}
                                            />
                                        </Col>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='projectName'>Nama Projek*</Form.Label>
                                            <Form.Control
                                                id='projectName'
                                                type="text"
                                                defaultValue={values?.projectName || ''}
                                                onChange={handleChange("projectName")}
                                                readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                required
                                                style={formStyles.input}
                                            />
                                        </Col>
                                        <Col xs={12} lg={3} className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='request'>Jenis Permintaan*</Form.Label>
                                            <Form.Control
                                                id='project'
                                                type="text"
                                                defaultValue={pcpData?.lead?.orderType || ''}
                                                readOnly
                                                style={formStyles.input}
                                            />
                                        </Col>
                                        <Col xs={12} lg={1} className="mb-3">
                                            <Form.Label style={formStyles.label}>Wapu</Form.Label>
                                            <Form.Check
                                                type='checkbox'
                                                id='default-checkbox'
                                                onChange={(e) => setWapu(e.target.checked)}
                                                checked={wapu}
                                                disabled={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                style={formStyles.label}
                                            />
                                        </Col>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='franco'>Franco*</Form.Label>
                                            <Form.Control
                                                id='franco'
                                                type="text"
                                                defaultValue={values?.franco || ''}
                                                onChange={handleChange("franco")}
                                                required
                                                readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                style={formStyles.input}
                                            />
                                        </Col>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='status'>Status Pcp</Form.Label>
                                            <Form.Control
                                                id='status'
                                                type="text"
                                                defaultValue={pcpData?.status || ''}
                                                readOnly
                                                style={formStyles.input}
                                            />
                                        </Col>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Label style={formStyles.label} >Credit Score</Form.Label>
                                            <div className='mt-2'>{renderStars(creditScore)}</div>
                                        </Col>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Group >
                                                <Form.Label style={formStyles.label} htmlFor='description'>Syarat dan ketentuan tambahan</Form.Label>
                                                <Form.Control
                                                    id="description"
                                                    as="textarea"
                                                    rows={3}
                                                    defaultValue={values?.description || ''}
                                                    onChange={handleChange("description")}
                                                    placeholder="Syarat dan ketentuan tambahan"
                                                    readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                    style={formStyles.input}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                                <div className={isMobile ? 'ms-1 mt-4' : 'ms-3 mt-4 me-3'}>
                                    <h3 className='text-center' style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222', fontSize: isMobile ? '25px' : '38px' }}>
                                        PCP Detail
                                    </h3>
                                    <Table className='mt-4' bordered responsive data-bs-theme={theme === "light" ? "dark" : "light"}>
                                        <thead>
                                            <tr style={{ fontFamily: 'Poppins-Regular', textAlign: 'center' }}>
                                                <th
                                                    style={{
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    Info
                                                </th>
                                                <th
                                                    style={{
                                                        textAlign: 'left'
                                                    }}
                                                >
                                                    Nama Produk
                                                </th>
                                                <th>
                                                    Jenis Produk
                                                </th>
                                                {pcpData?.lead?.orderType === 'penjualan' ?
                                                    (
                                                        <></>
                                                    )
                                                    :
                                                    (
                                                        <th>
                                                            Durasi (Bulan)
                                                        </th>
                                                    )

                                                }
                                                <th
                                                    style={{
                                                        textAlign: 'right'
                                                    }}
                                                >
                                                    Harga Beli
                                                </th>
                                                {pcpData?.lead?.orderType === 'penjualan' ?
                                                    (
                                                        <th
                                                            style={{
                                                                textAlign: 'right'
                                                            }}
                                                        >
                                                            Harga Jual
                                                        </th>
                                                    )
                                                    :
                                                    (
                                                        <th
                                                            style={{
                                                                textAlign: 'right'
                                                            }}
                                                        >
                                                            Harga Sewa Perbulan
                                                        </th>
                                                    )
                                                }
                                                <th>Qty</th>
                                                <th
                                                    style={{
                                                        textAlign: 'right'
                                                    }}
                                                >
                                                    Sub Total
                                                </th>
                                                <th
                                                    style={{
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    %
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pcpDetail.map((item, index) => {

                                                const marginTotal = (
                                                    (parseFloat(item.sellingPrice || 0) - parseFloat(item.buyingPrice || 0)) /
                                                    (parseFloat(item.sellingPrice || 1))
                                                ) * 100;

                                                const marginTotalSewa = ((parseFloat(item.nett) / parseFloat(item.subtotal))) * 100;

                                                const marginValidate = wapu ? (marginTotalSewa.toFixed(2) <= 26 ? false : true) : (marginTotalSewa.toFixed(2) <= 15 ? false : true);

                                                return (
                                                    <tr key={index} style={{ fontFamily: 'Poppins-Light', textAlign: 'center' }}>
                                                        <td style={{
                                                            textAlign: 'center',
                                                        }}>
                                                            {pcpData?.lead?.orderType === 'penjualan' ?
                                                                (
                                                                    <Button variant='btn'
                                                                        onClick={() => handleShowDetailPcpPenjualan(item)}
                                                                        disabled={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                                    >
                                                                        <FaInfoCircle size={20} color={theme === 'light' ? '#12B3ED' : '#006CB8'} />
                                                                    </Button>
                                                                )
                                                                :
                                                                (
                                                                    <Button variant='btn'
                                                                        onClick={() => handleShowDetailPcpSewa(item)}
                                                                    >
                                                                        <FaInfoCircle size={20} color={theme === 'light' ? '#12B3ED' : '#006CB8'} />
                                                                    </Button>
                                                                )
                                                            }
                                                        </td>
                                                        <td style={{
                                                            textAlign: 'left',
                                                            width: '350px'
                                                        }}>
                                                            {item?.productName}
                                                        </td>
                                                        <td>
                                                            {item?.category?.categoryName}
                                                        </td>
                                                        {pcpData?.lead?.orderType === 'penjualan' ?
                                                            (
                                                                <></>
                                                            )
                                                            :
                                                            (
                                                                <td>{(item.duration / 30)}</td>
                                                            )

                                                        }
                                                        <td style={{
                                                            textAlign: 'right'
                                                        }}>
                                                            {numberFormat(item.buyingPrice)}
                                                        </td>
                                                        <td style={{
                                                            textAlign: 'right'
                                                        }}>
                                                            {numberFormat(item.sellingPrice)}
                                                        </td>

                                                        <td>
                                                            {item.quantity || 0}
                                                        </td>
                                                        <td>
                                                            {numberFormat(item.subtotal || 0)}
                                                        </td>
                                                        {pcpData?.lead?.orderType === 'penjualan' ?
                                                            (
                                                                <td
                                                                    style={{
                                                                        textAlign: 'center'
                                                                    }}
                                                                >
                                                                    <span style={{
                                                                        color: (() => {
                                                                            const thresholdMargin = (() => {
                                                                                switch (item?.category?.id) {
                                                                                    case 1:
                                                                                        return wapu ? 16 : 10;
                                                                                    case 2:
                                                                                        return wapu ? 31 : 20;
                                                                                    case 3:
                                                                                        return wapu ? 41 : 30;
                                                                                    default:
                                                                                        return 0;
                                                                                }
                                                                            })();

                                                                            return marginTotal <= thresholdMargin ? '#FF0060' : '#16C47F';

                                                                        })()
                                                                    }}>
                                                                        {marginTotal.toFixed(2) ? `${marginTotal.toFixed(2)}%` : '0%'}
                                                                    </span>
                                                                </td>
                                                            )
                                                            :
                                                            (
                                                                <td
                                                                    style={{
                                                                        textAlign: 'center'
                                                                    }}
                                                                >
                                                                    <span style={{
                                                                        color: marginValidate == false ? '#FF0060' : '#16C47F'
                                                                    }}>
                                                                        {marginTotalSewa.toFixed(2) ? `${marginTotalSewa.toFixed(2)}%` : '0%'}
                                                                    </span>
                                                                </td>
                                                            )

                                                        }
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                    {pcpData?.lead?.orderType === 'penjualan' ?
                                        (
                                            <div className='mt-5'>
                                                <Row>
                                                    <Col xs={12} lg={4} className={isMobile ? 'mb-5 text-start' : 'text-start'}>
                                                        <Card
                                                            data-bs-theme={theme === 'light' ? 'dark' : ''}>
                                                            <Card.Body>
                                                                <div>
                                                                    <Form.Label style={formStyles.label} htmlFor='totalSelling'>Total Harga Jual</Form.Label>
                                                                    <Form.Control
                                                                        id='totalSelling'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        value={numberFormat(totalHargaJual) || 0}
                                                                        readOnly
                                                                        style={formStyles.input}
                                                                    />
                                                                    <Form.Label style={formStyles.label} htmlFor='ppn'>PPN%</Form.Label>
                                                                    <Form.Control
                                                                        id='ppn'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        value={ppnPercentage}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            if (/^\d*$/.test(value)) {
                                                                                setPpnPercentage(value);
                                                                            }
                                                                        }}
                                                                        required
                                                                        readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                                        style={formStyles.input}
                                                                    />
                                                                    <Form.Label style={formStyles.label} htmlFor='ppnValue'>PPN Amount</Form.Label>
                                                                    <Form.Control
                                                                        id='ppnValue'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        value={numberFormat(ppnAmount) || numberFormat(0)}
                                                                        readOnly
                                                                        style={formStyles.input}
                                                                    />
                                                                    <Form.Label style={formStyles.label} htmlFor='grandTotal'>Grand Total</Form.Label>
                                                                    <Form.Control
                                                                        id='grandTotal'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        value={numberFormat(grandTotal) || numberFormat(0)}
                                                                        readOnly
                                                                        style={formStyles.input}
                                                                    />
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                    <Col xs={12} lg={2} ></Col>
                                                    <Col xs={12} lg={6} >
                                                        <Card
                                                            data-bs-theme={theme === 'light' ? 'dark' : ''}
                                                        >
                                                            <Card.Body>
                                                                <div>
                                                                    <Row>
                                                                        <Col xs={12} lg={6}>
                                                                            <Form.Label style={formStyles.label} htmlFor='overHead'>Over Head (3%)</Form.Label>
                                                                            <Form.Control
                                                                                id='overHead'
                                                                                type='text'
                                                                                className='mb-3'
                                                                                defaultValue={numberFormat(pcpData?.overhead) || ''}
                                                                                readOnly
                                                                                style={formStyles.input}
                                                                            />
                                                                        </Col>
                                                                        <Col xs={12} lg={6}>
                                                                            <Form.Label style={formStyles.label} htmlFor='edlCost'>External Direct Labor Cost</Form.Label>
                                                                            <Form.Control
                                                                                id='edlCost'
                                                                                type='text'
                                                                                className='mb-3'
                                                                                onChange={handleChangeEDL}
                                                                                value={`Rp ${edlCost ? edlCost.toLocaleString('id-ID') : '0,00'}`}
                                                                                required
                                                                                readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                                                style={formStyles.input}
                                                                            />
                                                                        </Col>
                                                                        <Col xs={12} lg={6}>
                                                                            <Form.Label style={formStyles.label} htmlFor='delivCost'>Delivery Cost</Form.Label>
                                                                            <Form.Control
                                                                                id='delivCost'
                                                                                type='text'
                                                                                className='mb-3'
                                                                                onChange={handleChangeDeliveryCost}
                                                                                value={`Rp ${deliveryCost ? deliveryCost.toLocaleString('id-ID') : '0,00'}`}
                                                                                required
                                                                                readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                                                style={formStyles.input}
                                                                            />
                                                                        </Col>
                                                                        <Col xs={12} lg={6}>
                                                                            <Form.Label style={formStyles.label} htmlFor='financeCost'>Financial Cost</Form.Label>
                                                                            <Form.Control
                                                                                id='financeCost'
                                                                                type='text'
                                                                                className='mb-3'
                                                                                onChange={handleChangeFinancialCost}
                                                                                value={`Rp ${financialCost ? financialCost.toLocaleString('id-ID') : '0,00'}`}
                                                                                required
                                                                                readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                                                style={formStyles.input}
                                                                            />
                                                                        </Col>
                                                                        <Col xs={12} lg={6}>
                                                                            <Form.Label style={formStyles.label} htmlFor='otherFinanceCost'>Other Financial Cost</Form.Label>
                                                                            <Form.Control
                                                                                id='otherFinanceCost'
                                                                                type='text'
                                                                                className='mb-3'
                                                                                onChange={handleChangeOtherFinanceCost}
                                                                                value={`Rp ${otherFinancialCost ? otherFinancialCost.toLocaleString('id-ID') : '0,00'}`}
                                                                                required
                                                                                readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                                                style={formStyles.input}
                                                                            />
                                                                        </Col>
                                                                        <Col xs={12} lg={6}>
                                                                            <Form.Label style={formStyles.label} htmlFor='otherAllow'>Other Allowance</Form.Label>
                                                                            <Form.Control
                                                                                id='otherAllow'
                                                                                type='text'
                                                                                className='mb-3'
                                                                                onChange={handleChangeOtherAllowance}
                                                                                value={`Rp ${otherAllowance ? otherAllowance.toLocaleString('id-ID') : '0,00'}`}
                                                                                required
                                                                                readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                                                style={formStyles.input}
                                                                            />
                                                                        </Col>
                                                                        <Col xs={12} lg={6}>
                                                                            <Form.Label style={formStyles.label} htmlFor='subTotalCost'>Sub Total Cost</Form.Label>
                                                                            <Form.Control
                                                                                id='subTotalCost'
                                                                                type='text'
                                                                                className='mb-3'
                                                                                value={numberFormat(subTotalCost) || numberFormat(0)}
                                                                                readOnly
                                                                                style={formStyles.input}
                                                                            />
                                                                        </Col>
                                                                        <Col xs={12} lg={6}>
                                                                            <Form.Label style={formStyles.label} htmlFor='nettMargin'>Nett Margin</Form.Label>
                                                                            <InputGroup className="mb-3">
                                                                                <Form.Control
                                                                                    id='nettMargin'
                                                                                    type='text'
                                                                                    className='mb-3'
                                                                                    value={numberFormat(nettMargin) || '0,00'}
                                                                                    readOnly
                                                                                    style={formStyles.input}
                                                                                />
                                                                                <InputGroup.Text
                                                                                    id="basic-addon1"
                                                                                    style={formStyles.inputBodyGroup}
                                                                                >
                                                                                    {nettPercentage.toFixed(2) + '%'}
                                                                                </InputGroup.Text>
                                                                            </InputGroup>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                        <div className='text-end mt-4 mb-4'>
                                                            {userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ?
                                                                (
                                                                    <>
                                                                        {isSubmitting ? (
                                                                            <Button
                                                                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                                                variant='btn'
                                                                                disabled
                                                                                style={{ minWidth: '90px' }}
                                                                            >
                                                                                <Spinner
                                                                                    animation="border"
                                                                                    size='sm'
                                                                                />
                                                                            </Button>
                                                                        ) : (
                                                                            <Button
                                                                                variant='btn'
                                                                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                                                type='submit'
                                                                                disabled={disabled ||
                                                                                    pcpDetail == 0
                                                                                }
                                                                            >
                                                                                Simpan
                                                                            </Button>
                                                                        )}
                                                                    </>
                                                                )
                                                                :
                                                                (
                                                                    <></>
                                                                )
                                                            }
                                                            <Button
                                                                variant='secondary'
                                                                className='ms-3'
                                                                onClick={handleBack}
                                                                style={{ fontFamily: 'Poppins-Regular', minHeight: '45px' }}
                                                                disabled={
                                                                    pcpData?.grandTotal != grandTotal ||
                                                                    pcpData?.isWapu != wapu ||
                                                                    pcpData?.externalDirectLabor != edlCost ||
                                                                    pcpData?.deliveryCost != deliveryCost ||
                                                                    pcpData?.financialCost != financialCost ||
                                                                    pcpData?.otherFinancialCost != otherFinancialCost ||
                                                                    pcpData?.otherAllowance != otherAllowance
                                                                }
                                                            >
                                                                Kembali
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        )
                                        :
                                        (
                                            <div className='mt-5'>
                                                <Row>
                                                    <Col xs={12} lg={6} className='text-start'></Col>
                                                    <Col xs={12} lg={2} ></Col>
                                                    <Col xs={12} lg={4} >
                                                        <Card
                                                            data-bs-theme={theme === 'light' ? 'dark' : ''}
                                                        >
                                                            <Card.Body>
                                                                <div>
                                                                    <Form.Label style={formStyles.label} htmlFor='totalSelling'>Total Harga Jual</Form.Label>
                                                                    <Form.Control
                                                                        id='totalSelling'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        value={numberFormat(totalHargaJual) || 0}
                                                                        readOnly
                                                                        style={formStyles.input}
                                                                    />
                                                                    <Form.Label style={formStyles.label} htmlFor='ppn'>PPN%</Form.Label>
                                                                    <Form.Control
                                                                        id='ppn'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        value={ppnPercentage}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            if (/^\d*$/.test(value)) {
                                                                                setPpnPercentage(value);
                                                                            }
                                                                        }}
                                                                        required
                                                                        readOnly={userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ? false : true}
                                                                        style={formStyles.input}
                                                                    />
                                                                    <Form.Label style={formStyles.label} htmlFor='ppnValue'>PPN Amount</Form.Label>
                                                                    <Form.Control
                                                                        id='ppnValue'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        value={numberFormat(ppnAmount) || 0}
                                                                        readOnly
                                                                        style={formStyles.input}
                                                                    />
                                                                    <Form.Label style={formStyles.label} htmlFor='grandTotal'>Grand Total</Form.Label>
                                                                    <Form.Control
                                                                        id='grandTotal'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        value={numberFormat(grandTotal) || ''}
                                                                        readOnly
                                                                        style={formStyles.input}
                                                                    />
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                        <div className='text-end mt-4 mb-4'>
                                                            {userInfo?.role?.roleName === 'Supervisor' || userInfo?.role?.roleName === 'superuser' ?
                                                                (
                                                                    <>
                                                                        {isSubmitting ? (
                                                                            <Button
                                                                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                                                variant='btn'
                                                                                disabled
                                                                                style={{ minWidth: '90px' }}
                                                                            >
                                                                                <Spinner
                                                                                    animation="border"
                                                                                    size='sm'
                                                                                />
                                                                            </Button>
                                                                        ) : (
                                                                            <Button
                                                                                variant='btn'
                                                                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                                                type='submit'
                                                                                disabled={disabled ||
                                                                                    pcpDetail == 0
                                                                                }
                                                                            >
                                                                                Simpan
                                                                            </Button>
                                                                        )}
                                                                    </>
                                                                )
                                                                :
                                                                (
                                                                    <></>
                                                                )
                                                            }
                                                            <Button
                                                                variant='secondary'
                                                                className='ms-3'
                                                                onClick={handleBack}
                                                                style={{ fontFamily: 'Poppins-Regular', minHeight: '45px' }}
                                                                disabled={
                                                                    pcpData?.grandTotal != grandTotal ||
                                                                    pcpData?.isWapu != wapu
                                                                }
                                                            >
                                                                Kembali
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        )
                                    }
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>

            <ModalUbahPcpDetail
                rowSelected={rowSelected}
                pcpData={pcpData}
                showEditPcpDetail={showDetailPcpPenjualan}
                setShowEditPcpDetail={setShowDetailPcpPenjualan}
                listCategory={listCategory}
                formStyles={formStyles}
                selectStyles={selectStyles}
                retrievePCPDetail={retrievePCPDetail}
            />

            <ModalDetailPcpSewa
                rowSelected={rowSelected}
                showDetailPcpSewa={showDetailPcpSewa}
                setShowDetailPcpSewa={setShowDetailPcpSewa}
                pcpData={pcpData}
                retrievePCPDetail={retrievePCPDetail}
            />

            <ModalUbahLead
                rowSelected={rowSelectedLead}
                showEditLead={showEditLead}
                setShowEditLead={setShowEditLead}
                retrieveLead={null}
                accessToken={accessToken}
            />
        </div>
    )
}

export default PcpDetail
